module.exports = __webpack_public_path__ + "media/images/elionline/icons/player_nascondi_revisioni-a13b071f4b4c98be492b310af6fd5868.svg";